import { render, staticRenderFns } from "./ProfileCreatorVideos.vue?vue&type=template&id=635d5c51&scoped=true&"
import script from "./ProfileCreatorVideos.vue?vue&type=script&lang=js&"
export * from "./ProfileCreatorVideos.vue?vue&type=script&lang=js&"
import style0 from "./ProfileCreatorVideos.vue?vue&type=style&index=0&id=635d5c51&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635d5c51",
  null
  
)

export default component.exports